import {Component} from '@angular/core';
import {FormGroup, NonNullableFormBuilder, Validators} from "@angular/forms";
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-withdraw-limit-modal',
  templateUrl: './withdraw-limit-modal.component.html',
  styleUrls: ['./withdraw-limit-modal.component.scss']
})
export class WithdrawLimitModalComponent {

  public withDrawLimitForm: FormGroup = this.fb.group({
    withdrawLimit: [0, [Validators.required, Validators.min(0)]],
    reason: ['', [Validators.required]]
  })

  constructor(private fb: NonNullableFormBuilder,
              public dialogRef: MatDialogRef<WithdrawLimitModalComponent>) {
  }

  public setStoreWithdrawLimit(): void {
    this.dialogRef.close(this.withDrawLimitForm.value);
  }

  public close(): void {
    this.dialogRef.close();
  }

}
